import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Api } from '../../Model/api-model';
import { environment } from '../../../environments/environment';
import { RestApiService } from 'src/app/Services/rest-api-service';
import {Message,MessageService} from 'primeng/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SwaggerUIBundle, SwaggerUIStandalonePreset } from "swagger-ui-dist";
import { MySubscriptions, Subscription, ProductPlan, Plan, PlanApis } from 'src/app/Model/product-model';
@Component({
  selector: 'details-swag-static',
  templateUrl: './swaggerdetails.component.html'
})
export class SwaggerDetailsComponent {
  apiID;
  apiURL;
  showDiv=false;
  fileName;
 
  constructor(private http: HttpClient,private route: ActivatedRoute) { 
  
    this.route.params.subscribe(params => {
    
     
    
      if(environment.getAemurl()=='none'){
        this.fileName='/'+params['file'];
  
      }else{
        this.fileName=environment.getAemurl()+'/yaml/'+params['file'];
        //this.fileName='/'+params['file'];
      }
      
     
  
    })
   
  }

  @ViewChild('details') myDiv: ElementRef;

 

  ngAfterViewInit() {
    this.myDiv.nativeElement.focus(); 

    
    const ui = SwaggerUIBundle({
     // url:  "https://iopapicdevportalservicesvte-oci-dev.aetapps-dev.aetna.com/iopapicdevportalservicesvte/v1/devportalusers/api/5f0c70bbe4b003d499c65cdc",
      url:this.fileName,
      dom_id: '#swagger-ui',
      deepLinking: false,
      defaultModelsExpandDepth:-1,
      presets: [
        SwaggerUIBundle.presets.apis
      //  SwaggerUIStandalonePreset
      ]
    })
  }

 

}
